import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';

export interface DropdownOptionsProps {
  /** The list of options to display */
  options: string[];
  /** The currently selected value */
  value: string;
  /** Callback when the selection changes */
  onChange: (value: string) => void;
  /** The label for the dropdown */
  label?: string;
  /** Whether the control should take full width */
  fullWidth?: boolean;
  /** Whether the dropdown is disabled */
  disabled?: boolean;
}

export default function DropdownOptions({
  options,
  value,
  onChange,
  label = 'Correct Answer',
  fullWidth = true,
  disabled = false,
}: DropdownOptionsProps) {
  const trimmedOptions = options.map((option) => option.trim());
  const filteredOptions = trimmedOptions.filter((option) => option !== '');
  const newValue = filteredOptions.includes(value) ? value : '';
  return (
    <FormControl fullWidth={fullWidth} data-testid="dropdown-options">
      <InputLabel>{label}</InputLabel>
      <Select value={newValue} onChange={(e) => onChange(e.target.value)} label={label} disabled={disabled}>
        {filteredOptions.map((option, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <MenuItem key={`option-${index}-${option}`} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
